export default {
  name: "ZoomSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};